export default __webpack_public_path__ + "static/media/joshua-adam-nolette.15a2dee8.jpg";